module.exports = __webpack_public_path__ + "img/cby1.1fec2a96.gif";